// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { ShipmentStatusCollectionModel } from "@store/Framework/Types/ApiModels";
import { GetShipmentStatusesApiParameter } from "@store/Framework/Services/ShipmentService";
import ShipmentStatusesState from "@store/Framework/Store/Greif/Data/ShipmentStatuses/ShipmentStatusesState";
import { Draft } from "immer";

const initialState: ShipmentStatusesState = {
    byId: {},
    isLoading: {},
    dataViews: {},
};

const actions = {
    "Greif/Data/ShipmentStatuses/BeginLoadShipmentStatuses": (
        draft: Draft<ShipmentStatusesState>,
        action: { parameter: GetShipmentStatusesApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Greif/Data/ShipmentStatuses/CompleteLoadShipmentStatuses": (
        draft: Draft<ShipmentStatusesState>,
        action: { parameter: GetShipmentStatusesApiParameter; collection: ShipmentStatusCollectionModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => Object(collection)!);
    },

    "Greif/Data/ShipmentStatuses/Reset": () => {
        return initialState;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataShipmentStatusesActions = Parameters<typeof reducer>[1];
export default reducer;
